export default __webpack_public_path__ + "static/media/fad-save.aa713b78.svg";